import { Card, Row, Col } from "react-bootstrap";

const StudentCard = ({ student }) => {
  return (
    <>
      <Card className="mb-4 shadow-sm border-0 info-card">
        <Card.Body className="d-flex align-items-center justify-content-start flex-wrap p-4">
          <div className="d-flex align-items-center">
            <div className="avatar me-3">
              <span className="">
                {student?.name?.charAt(0) +
                  student?.name?.split(" ")[1]?.charAt(0)}
              </span>
            </div>
            <div>
              <h5 className="mb-1">{student?.name}</h5>
              <p className="mb-0 text-color">
                Student ID : <strong>{student?.username}</strong>
              </p>
            </div>
          </div>

          <div className="d-flex flex-column align-items-start mt-3 mt-md-0 student-meta">
            <p className="mb-1 text-color">
              Age : <strong>{student?.age}</strong>
            </p>
            <p className="mb-0 text-color">
              Email : <strong className="email">{student?.email}</strong>
            </p>
          </div>
        </Card.Body>
      </Card>
      <Row className="g-4 mb-4">
        <Col md={4}>
          <Card className="stat-card  progress-card">
            <Card.Body>
              <p className="mb-1 fw-medium small">Overall Progress %</p>
              <h3 className="fw-bold">{student?.progress}%</h3>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="stat-card  quiz-card">
            <Card.Body>
              <p className="mb-1  fw-medium small">Average Quiz Score %</p>
              <h3 className="fw-bold">{student?.avgScore}%</h3>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="stat-card quests-card">
            <Card.Body>
              <p className="mb-1 fw-medium small">Total Quests Assigned</p>
              <h3 className="fw-bold">0{student?.totalQuests}</h3>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default StudentCard;
